<template>
  <div class="leading-normal px-12">
    <icon name="tick_circle" :center="false" class="mx-auto mb-1 w-24 h-24 text-print-order-teal" />
    <h3 class="text-center mb-4">Thank you for your order</h3>
    <hr class="border-b border-grey-light mb-2">
    <table class="w-full mb-8">
      <tbody>
        <template v-for="(item, i) in basketItems">
          <tr :key="i" :class="{'border-t': i > 0}">
            <td class="text-left pt-6 pb-6 pr-4">
              <h4 class="text-base font-bold mb-1">{{ item.sale_item_category.name + ' - ' + item.sale_item.name }}</h4>
              <p class="text-sm font-bold mb-6">Quantity: {{ item.quantity }}</p>
              <p v-if="item.print_spec" class="text-sm">{{ item.print_spec.name }}</p>
            </td>
            <td class="align-top text-right text-sm mb-6 pt-6 leading-loose">
              {{ parseFloat(item.item_quote) | gbp }}
            </td>
          </tr>
          <tr v-if="item.artwork_item_price" :key="i + '-artwork-' + item.artwork_item_price.id">
            <td class="text-left mb-4 pt-6 pr-4" :class="{'pb-6': !item.delivery_item_price}">
              <h4 class="text-base font-bold mb-1">Artwork Creation</h4>
            </td>
            <td class="align-top text-right text-sm mb-6 pt-6 leading-loose" :class="{'pb-6': !item.delivery_item_price}">
              {{ item.artwork_quote | gbp }}
            </td>
          </tr>
          <tr v-if="item.delivery_item_price" :key="i + '-delivery-' + item.delivery_item_price.id">
            <td class="text-left py-6 pr-4">
              <h4 class="text-base font-bold mb-1">Delivery</h4>
            </td>
            <td class="align-top text-right text-sm py-6 leading-loose">
              {{ item.delivery_quote | gbp }}
            </td>
          </tr>
        </template>
        <tr v-if="vat > 0" class="border-t border-grey-light text-right">
          <td colspan="2" class="text-sm pt-6 pb-2">VAT {{ vat | gbp }}</td>
        </tr>
        <tr class="text-right">
          <td colspan="2" class="text-xl font-bold" :class="{'pb-6 border-b border-grey-light': !additionalDelivery}">{{ total | gbp }}</td>
        </tr>
        <tr v-if="additionalDelivery">
          <td colspan="2" class="border-b border-grey-light align-top text-right text-xs pb-6">+ unknown delivery charge</td>
        </tr>
      </tbody>
    </table>
    <table class="w-full mb-6">
      <tbody>
        <tr>
          <td class="w-1/2 text-right pr-4">{{ 'Reference: ' + selectedOffice.name }}</td>
          <td class="w-1/2 text-left pl-4">{{ 'Order No.: ' + receipt.id }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      name: 'Custom Print Order'
    }
  },
  props: ['order', 'basketItems', 'receipt', 'subtotal', 'vat', 'total', 'additionalDelivery'],
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
  },
  methods: {
  }
}
</script>
